import React from 'react';
import { useAuth } from '../../context/AuthContext';

export const ASSET_MODULES = ['fixed-assets', 'asset-acquisitions', 'asset-depreciation', 'asset-operations', 'asset-reports', 'asset-settings'];
export const hasAssetModule = (user, module) => user?.role === 'admin' || (user?.employee_permissions || []).includes(module) || ({
  manager: ['fixed-assets', 'asset-acquisitions', 'asset-operations', 'asset-reports'],
  accountant: ['fixed-assets', 'asset-acquisitions', 'asset-depreciation', 'asset-reports', 'asset-settings'],
  accounts: ['fixed-assets', 'asset-acquisitions', 'asset-depreciation', 'asset-reports', 'asset-settings'],
  store: ['fixed-assets', 'asset-acquisitions', 'asset-operations'],
  employee: ['fixed-assets', 'asset-operations'], staff: ['fixed-assets', 'asset-operations'],
}[user?.role] || []).includes(module);

export default function AssetPermissionGuard({ module = 'fixed-assets', children, fallback = null }) {
  const { user } = useAuth();
  return hasAssetModule(user, module) ? children : fallback;
}
